export enum PlaylistType {
  MUSIC = 0,
  MIX = 1
}
